import MultiCascader from './MultiCascader';

// export types
export type { MultiCascaderProps } from './MultiCascader';

// export components
export { MultiCascader };
export default MultiCascader;
